import React from "react";
import Productpage from "../../productpage2";
import SEO from "../../seo";
const featureimg1 =
  "https://eclipsemattress.in/assets/images/products/vienna-et/Vienna-04.jpg";
const gal1 =
  "https://eclipsemattress.in/assets/images/products/vienna-et/Vienna-01.png";
const gal2 =
  "https://eclipsemattress.in/assets/images/products/vienna-et/Vienna-02.png";
const gal3 =
  "https://eclipsemattress.in/assets/images/products/vienna-et/Vienna-03.png";

const warranty =
  "https://eclipsemattress.in/assets/images/products/vienna-et/warranty2.png";

const icon1 =
  "https://eclipsemattress.in/assets/images/products/vienna-et/Vienna-07.png";
const icon2 =
  "https://eclipsemattress.in/assets/images/products/vienna-et/Vienna-08.png";
const icon3 =
  "https://eclipsemattress.in/assets/images/products/vienna-et/Vienna-09.png";
const icon4 =
  "https://eclipsemattress.in/assets/images/products/vienna-et/Vienna-10.png";
const icon5 =
  "https://eclipsemattress.in/assets/images/products/vienna-et/Vienna-11.png";

const features =
  "https://eclipsemattress.in/assets/images/products/vienna-et/features.png";

export default function ViennaETPage({ location }) {
  const data = {
    productName: "VIENNA ET",
    galleryImages: [featureimg1, gal1, gal2, gal3],
    productLogo:
      "https://eclipsemattress.in/wp-content/uploads/2021/06/Eclipse_sub-brand_logo-01.png",
    descriptionTitle:
      "Bonnel Spring, Natural Latex & Spinal Zone Patented Mattress",
    descriptionText:
      "Taking into consideration your value for comfort. We have designed the most comfortable mattress you could ever want. Vienna uses Natural latex in a Euro-Top construction, and in combination with Spinal Zone patented technology. It is the ideal choice for anyone with back & neck issues. Vienna is an unmatched sleeping surface that provides additional support to the torso. Vienna supports your spine – and you!",
    availableSizes: "8″ & 10″",
    category: { title: "Patent Series", link: "/patent-series-mattress/" },
    points: [
      "416 heavy gauge Bonnell Innersprings",
      "Natural Latex in Euro Top construction",
      "Spinal Zone patented technology for enhanced back & neck support",
      "Extra lumbar support",
      "Patented Life Edge Perimeter Support technology",
    ],
    featuresText: [
      "Eclipse HD Plush foam for quilting",
      "Eclipse Natural Belgium Latex",
      "HD Eclipse Pure Foam",
      "Turkish Cotton Felt",
      "PP Mesh for durability",
      "Chiropractic Bonnell Spring",
      "Patented Life Edge Perimeter Support",
    ],
    featuresImage: features,
    warrantyIcons: [
      "https://eclipsemattress.in/assets/features/logo-04.png",
      "https://eclipsemattress.in/assets/features/logo-05.png",
      "https://eclipsemattress.in/assets/features/logo-06.png",
      "https://eclipsemattress.in/assets/features/logo-01.png",
      icon1,
      icon2,
      icon3,
      icon4,
      icon5,
    ],

    warrantyImage: warranty,
    price: "₹35,699 - ₹1,11,999",
    brochureLink:
      "https://eclipsemattress.in/assets/pdfs/Patent-&-Luxury-Catalogue.pdf",

    relatedProducts: [
      {
        title: "Coil On Coil",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/coiloncoil.jpg",
        link: "/patent-series-mattress/coil-on-coil/",
      },
      {
        title: "Posture Therapy",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/posture-therapy.jpg",
        link: "/luxury-collection/posture-therapy/",
      },
      {
        title: "Posture Care",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/posture-care.jpg",
        link: "/luxury-collection/posture-care/",
      },
    ],
  };

  return (
    <div>
      <SEO
        title="Vienna Natural Latex Mattress | Eclipse International"
        description="Buy Vienna natural latex mattress with 10 years warranty designed with spinal zone patented technology considering ideal for back and neck issues for a comfortable sleep."
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-viennaet.jpg"
      />
      <Productpage location={location} product={data} />
    </div>
  );
}
